import { formatDate } from '@/utils/helpers'
import formatTaskHelper from '@/store/ui/dataEntry/helpers'
import utils from './utils'

import { get, isEmpty, includes, isNil } from 'lodash'
import dayjs from 'dayjs'

const helpers = {
    parseData: (data, accountId) => {
        const _connections = []
        const _configs = []
        const _jobs = []
        for (const [idx, val] of data.entries()) {
            // do not display if status = deleted
            if (val.status !== 'deleted') {
                // CONNECTIONS
                const connectionData = {
                    ...val,
                    created_at: formatDate(val.created_at),
                    deleted_at: formatDate(val.deleted_at),
                    displayOrder: idx,
                    error_msg: val.error_msg === null ? '' : val.error_msg,
                    hasChild: utils.hasChild(get(val, 'feedcrm_configs', null)),
                    jsonKey: {
                        type: 'connection',
                        subType: val.type,
                        ids: [val.id],
                        name: `connection-${val.id}`
                    },
                    parentJsonKeyName: null,
                    updated_at: formatDate(val.updated_at)
                }
                _connections.push(connectionData)

                // CONFIGURATIONS
                if (val.feedcrm_configs && !isNil(val.feedcrm_configs) && !isEmpty(val.feedcrm_configs)) {
                    for (const [idx, config] of val.feedcrm_configs.entries()) {
                        if (config.status !== 'deleted') {
                            const _task = utils.jsonParse(config.task)
                            const configData = {
                                ...config,
                                account_id: accountId,
                                created_at: formatDate(config.created_at),
                                deleted_at: formatDate(config.deleted_at),
                                displayOrder: idx,
                                finish_alert_emails: utils.jsonParse(config.finish_alert_emails),
                                hasChild: utils.hasChild(get(config, 'feedcrm_jobs', null)),
                                is_file_compressed: utils.setBoolean(config.is_file_compressed),
                                is_proxy_mode: utils.setBoolean(config.is_proxy_mode),
                                is_weboid_crypted: utils.setBoolean(config.is_weboid_crypted),
                                jsonKey: {
                                    type: 'configuration',
                                    subType: includes(_task, 'crm') ? 'Offline Datalayer' : includes(_task, 'wam_proxy') ? 'Proxy' : 'CRM',
                                    ids: [config.id],
                                    name: `configuration_${config.id}`
                                },
                                parentJsonKeyName: connectionData.jsonKey.name,
                                remove_remote_files: utils.setBoolean(config.remove_remote_files),
                                task: _task,
                                updated_at: formatDate(config.updated_at)
                            }
                            _configs.push(configData)

                            // JOBS
                            if (config.feedcrm_jobs && !isNil(config.feedcrm_jobs) && !isEmpty(config.feedcrm_jobs)) {
                                for (const [idx, job] of config.feedcrm_jobs.entries()) {
                                    const displayTpe = formatTaskHelper['ui/dataEntry/jobType']({ type: job.task })
                                    const jobData = {
                                        ...job,
                                        account_id: accountId,
                                        createdAt: formatDate(job.created_at),
                                        defectuous: isNil(job.defectuous) ? null : utils.setBoolean(job.defectuous),
                                        displayOrder: idx,
                                        file_date: isNil(job.file_date) ? 'Invalid date' : dayjs(job.file_date).format('YYYYMMDD'),
                                        finish_alert_emails: utils.jsonParse(job.finish_alert_emails),
                                        hasChild: false,
                                        is_compressed: utils.setBoolean(job.is_compressed),
                                        is_weboid_crypted: utils.setBoolean(job.is_weboid_crypted),
                                        jsonKey: {
                                            type: 'job',
                                            subType: null,
                                            ids: [job.id],
                                            name: `job_${job.id}`
                                        },
                                        label: job.filename,
                                        parentJsonKeyName: configData.jsonKey.name,
                                        partner_seg_types: utils.jsonParse(job.partner_seg_types),
                                        type: utils.jsonParse(job.task), //task (key "type" to fit table filtering)
                                        displayType: displayTpe,
                                        updatedAt: formatDate(job.updated_at)
                                    }
                                    _jobs.push(jobData)
                                }
                            }
                        }
                    }
                }
            }
        }
        return [..._connections, ..._configs, ..._jobs]
    }
}

export default helpers
